import {createContext, useContext, useState, useEffect} from "react";
//import React, { useContext, useState, useRef, useEffect} from 'react';

import { useTranslation } from 'react-i18next';
import axios from 'axios';
import "./product.css";
//import db from "../data/db";
//import { useState } from "react";
import { GrFormClose } from "react-icons/gr";
const descriptionText = createContext(null);

const Product = () => {
  const [detail, setDetail] = useState([]);
  const [closeModal, selCloseModal] = useState(false);
  const [actualItem, setActualItem] = useState('');

  const detailPage = (Product) => { setActualItem(Product);
                                    selCloseModal(true);         
                                    setActiveDescription("Products/fr_" + Product.id + ".txt");
                                  };
  const { t } = useTranslation();
  //const { i18n } = useTranslation();

  const [activeDescription, setActiveDescription] = useState([]);

  axios.get('Products/lesArticles.json')
       .then(response => { const ItemsListe = response.data.map(item => (
                             { id: item.id,
                               image: item.image,
                               title: item.title,
                               title1: item.title1,
                               desc: item.desc,
                               category: item.category,
                               category1: item.category1,
                               type: item.type,
                               type1: item.type1,
                               price: item.price,
                             } ));
                           setDetail(ItemsListe);
                         }
            ).catch(error => { console.error(error); // Perform custom error handling, show error message, etc.
                             }
                   );
                   
  return (
    <div className="container">
      {closeModal ? (
        <div className="detail-container">
          <div>
            <button className="close" onClick={() => selCloseModal(false)}><GrFormClose /></button>
               <div className="detail-info">
                   <img style={{ objectFit: "cover", 
                                 /*La propriété CSS object-fit définit la façon dont le contenu d'un élément remplacé */
                                 /*<img> ou <video> doit s'adapter à son conteneur en utilisant sa largeur et sa hauteur.*/
                                 borderRadius: "50%", float: "left", 
                                 shapeOutside: "margin-box", 
                                 margin: "0 10px 0 0", 
                                 width: "400px", height: "400px" }}
                        src={actualItem.image} alt={actualItem.title1} />
                   <div>
                       <descriptionText.Provider value={activeDescription}>
                           <ChildComponent />
                       </descriptionText.Provider>
                       <button style={{ fontWeight: "600", marginTop: "1.25rem",
                                        padding: "0.625rem 1.875rem", outline: "none",
                                        border: "1px solid var(--primary)", borderRadius: "1.8rem",
                                        cursor: "pointer", backgroundColor: "hsl(180, 100%, 25%)", 
                                        color: "var(--white)" }}>
                           {t('Product.Add2Cart' )}</button>
                   </div>
               </div>
          </div>
        </div>
      ) : null}

      <section className="product">
        {detail.map((product) => (
          <div className="card" key={product.id}>
            <div className="contant">
              <div className="card-img">
                <img src={product.image} alt={product.title1} className="" />
              </div>

              <div className="detail">
                <div className="info">
                  <h3 className="title">{product.title1}</h3>
                  <p className="price">{product.price}&nbsp;€</p>
                </div>

                <button onClick={() => detailPage(product)}>{t('Product.Details')}</button>
              </div>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Product;


const getTextFile = async (fileName) => 
{ const res = await fetch(`${process.env.PUBLIC_URL}/${fileName}`);
  
  // check for errors
  if (!res.ok) {throw res;}
  
  return res.text();
};

function ChildComponent() 
{ const fileName = useContext(descriptionText);
  const [text, setText] = useState("");
  
  useEffect(() => 
  { getTextFile(`${fileName}`).then(setText).catch(console.error); }, [fileName]);
  

  //très instrctif: https://www.learnbestcoding.com/post/84/string-to-html-in-react-js
  return(<p dangerouslySetInnerHTML={{__html: text}}></p>)
}
